import $ from 'jquery'
import jQuery from 'jquery';
import Sprite from './w-sprite';
import CustomParallax from './w-custom-parallax';

class CustomParallaxWrapper{
  constructor(obj) {
    const { element, countFrames } = obj;
  
    this.el = jQuery(element);
    this.countFrames = countFrames || 10;

    this._init();
  }

  _init(){
    const sprite = new Sprite({
      element: $('.s-custom-parallax__sprite', this.el),
      frameElement: $('.s-custom-parallax__frame', this.el),
      countFrames: this.countFrames,
    //  size: 100
    })

    new CustomParallax({
      element: this.el,
      elementNodes: $('.s-custom-parallax__item', this.el),
      callback: (i) => {
        //sprite.goto(i)
        // console.log(`Active text: index ${i}`)
      },
      scrollCallback: (top) => {
        // console.log('_calculateSpritePosition', top, this._calculateSpritePosition(top))
        const frame = this._calculateSpritePosition(top)
        
        sprite.goto(frame)

      }

    })
  }

  _calculateSpritePosition(scrolled) {    
    const y1 = Math.max(scrolled, 0)
    const y2 = y1 + this.el.outerHeight()
    const step = Math.floor(y2 - y1) / this.countFrames
 
    let current = 0

    if(scrolled<0){
      console.log('if')
      return current 
    } else {
      console.log('else')
      const analogy = Math.ceil(scrolled / step)
      return analogy
    }
  }
}
export default CustomParallaxWrapper;